import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { filmsApi } from "../api/filmsApi";
import { Vendor_Entity } from "../../entities/vendor";

const vendorsAdapter = createEntityAdapter<Vendor_Entity>();
const initialState = vendorsAdapter.getInitialState();

export const vendorEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getVendors: build.query<EntityState<Vendor_Entity>, void>({
      query: () => `vendors`,
      transformResponse: (responseData: Vendor_Entity[]) => {
        return vendorsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["vendors"],
    }),
    getVendor: build.query<Vendor_Entity, number>({
      query: (id) => `vendors/${id}`,
      providesTags: (result, error, id) => [{ type: "vendors", id }],
    }),
    createVendor: build.mutation<Vendor_Entity, Partial<Vendor_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `vendors`,
      }),
      invalidatesTags: ["vendors"],
    }),
    updateVendor: build.mutation<
      void,
      { id: number; body: Partial<Vendor_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `vendors/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "vendors", id },
        "vendors",
      ],
    }),
    deleteVendor: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `vendors/${id}`,
      }),
      invalidatesTags: ["vendors"],
    }),
  }),
});

export const {
  useGetVendorQuery,
  useGetVendorsQuery,
  useCreateVendorMutation,
  useDeleteVendorMutation,
  useUpdateVendorMutation,
} = vendorEndpoints;

export default vendorEndpoints;
